import Validation from "@/classes/global/Validation";

export class AddressBaseValidation {
    constructor() {

        this.name = new Validation();
        this.addressLine1 = new Validation();
        this.addressLine2 = new Validation();
        this.city = new Validation();
        this.county = new Validation();
        this.postCode = new Validation();
        this.country = new Validation();
        this.vatNumber = new Validation();
        this.firstName = new Validation();
        this.lastName = new Validation();
    }
}